import { ISvgProps, Svg } from '@components';
import { memo } from 'react';

export const BackgroundIcon = memo<ISvgProps>((props, { className }) => (
  <Svg className={className} width="1920" height="1080" viewBox="0 0 1920 1080" {...props}>
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_4419"
          data-name="Rectangle 4419"
          width="1920"
          height="1080"
          transform="translate(-1152)"
          fill="#3477eb"
        />
      </clipPath>
      <linearGradient
        id="linear-gradient"
        x1="0.5"
        x2="0.5"
        y2="0.739"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#64d7a4" />
        <stop offset="1" stopColor="#64d7a4" stopOpacity="0" />
      </linearGradient>
      <linearGradient id="linear-gradient-2" y2="1" xlinkHref="#linear-gradient" />
    </defs>
    <g id="bg" transform="translate(1152)" clipPath="url(#clip-path)">
      <path
        id="Path_21471"
        data-name="Path 21471"
        d="M9227.2,7657.9c-14.232-69.824-1.054-55.176-152.143-127.358s-215.635,91.767-298.563,162.452-162.844,106.95-136.3,198.65S8668.163,8008.6,8824.7,8038.29s264.271-36.613,313.5-82.262S9241.43,7727.725,9227.2,7657.9Z"
        transform="translate(-8285 -6826)"
        fill="url(#linear-gradient)"
      />
      <path
        id="Path_21472"
        data-name="Path 21472"
        d="M8991.5,6707.769c-.911,89.469-110.521,85.035-202.194,167.545s-89.17,188.139-214.767,235.3-250.284,83.9-355.581,34.863S7976.525,6960.75,8086.754,6813.1s318.382-171.286,397.73-150.278,263.464-94.473,343.19-70.4S8992.415,6618.3,8991.5,6707.769Z"
        transform="translate(-9437 -6724)"
        fill="url(#linear-gradient-2)"
      />
    </g>
  </Svg>
));

BackgroundIcon.displayName = 'BackgroundIcon';

export default BackgroundIcon;
